function Button({ children, onClick, variant = 'primary', className = '' }) {
    const baseStyles = 'px-4 py-2 rounded-lg font-semibold transition-colors duration-200';
    const variants = {
        primary: 'bg-pink-600 hover:bg-pink-700 text-white',
        danger: 'bg-red-600 hover:bg-red-700 text-white',
        secondary: 'bg-gray-600 hover:bg-gray-700 text-white'
    };

    return (
        <button
            className={`${baseStyles} ${variants[variant]} ${className}`}
            onClick={onClick}
        >
            {children}
        </button>
    );
}

export default Button;